import CustomerAIPredictionsView from 'views/CustomerAIPredictions'

const CustomerAIPredictions = () => <CustomerAIPredictionsView />

export default CustomerAIPredictions
